module.exports = __webpack_public_path__ + "static/7-1b7c10a53cd3deba4eff2e0365406058.jpeg";